import {
  put,
  //  , takeEvery, throttle, select
} from 'redux-saga/effects'
import { Game } from '../../Core'
import IndicatorContainer from './IndicatorContainer'
import TableIndicator from './TableIndicator'

/**
 *  Init module.
 */
function* init() {
  yield loadComponents()
}

/** loadComponents **/
export function* loadComponents() {
  const components = {
    IndicatorContainer,
    TableIndicator,
  }
  yield put(Game.actions.registerComponents(components))
}

/**
 *  Calendar sagas entrypoint
 */
export function* sagas() {
  yield init()
}
